var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYubi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:currentColor;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256.5,29.5c-109,0-111,147-111,178c0,25.99,5.81,249.76,6.85,280.67c0.08,2.43,2.05,4.36,4.48,4.41 c0,0,62.66,1.92,99.66,1.92s99.66-1.92,99.66-1.92c2.43-0.05,4.4-1.98,4.48-4.41c1.05-30.91,6.85-254.69,6.85-280.67 C367.5,176.5,365.5,29.5,256.5,29.5z M256.5,42.5c17.97,0,32.67,5.02,44.71,13.44c8.29,7.56,12.29,52.56,12.29,83.56 c0,37.26-6.07,65.26-7.94,73.01c-0.31,1.26-1.44,2.14-2.74,2.14l-46.32-0.15l-46.32,0.15c-1.3,0-2.43-0.88-2.74-2.14 c-1.87-7.74-7.94-35.75-7.94-73.01c0-31,4-76,12.29-83.56C223.83,47.52,238.53,42.5,256.5,42.5z M355.5,230.5 c0,26.26-6.87,218.43-7.88,246.57c-0.07,1.92-1.65,3.43-3.57,3.43H256.5h-87.56c-1.92,0-3.5-1.51-3.57-3.43 c-1.01-28.13-7.88-220.31-7.88-246.57c0-23.9-0.89-122.68,44.75-166.68c-5.75,10.69-12.75,43.69-9.75,94.68 c2.21,37.64,4.97,53.59,6.27,59.36c0.37,1.65,1.83,2.81,3.52,2.81h54.21h54.21c1.69,0,3.15-1.16,3.52-2.81 c1.29-5.77,4.05-21.71,6.27-59.36c3-50.99-4-83.99-9.75-94.68C356.39,107.82,355.5,206.6,355.5,230.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M301.5,294.5h-45h-45c-2.21,0-4,1.79-4,4c0,2.21,1.79,4,4,4h45h45c2.21,0,4-1.79,4-4 C305.5,296.29,303.71,294.5,301.5,294.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M281,337.5h-24.5H232c-2.21,0-4,1.79-4,4c0,2.21,1.79,4,4,4h24.5H281c2.21,0,4-1.79,4-4C285,339.29,283.21,337.5,281,337.5 z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYubi);
export default __webpack_public_path__ + "static/media/yubi.563592253bd0d10906738260047068c1.svg";
export { ForwardRef as ReactComponent };